import { useEffect, useState } from "react";
import DocumentsDetails from "../Documents/DocumentsDetails";
import { ITechincalDocument } from "src/Utils/Hooks/Downloads/useGetTechicalDocuments";
import markeingMaterial from 'src/images/additional-marketing-material.png';
import { Config } from "src/Utils/ConfigService/LoadConfig";
import { useTranslation } from "react-i18next";

const MarketingMaterialDocuments: React.FC = () => {
    const { t } = useTranslation();
    const [data, setData] = useState<ITechincalDocument[]>();

    useEffect(() => {
        const marketing_data: ITechincalDocument = {
            displayName: t('AdditionalMarketingMaterial'),
            previewData: markeingMaterial,
            sasToken: Config.GetConfigData().marketingMaterialUrl,
        }
        setData([marketing_data])
    }, [t])
    return (
        <>
            {data &&
               <DocumentsDetails data={data} title={t('MarketingMaterial')} id="marketing-material-doc" />
            }
        </>
    )
}
export default MarketingMaterialDocuments;